import React from 'react';
import SavedPosts from '../../components/saved/SavedPosts'

export default function Saved() {
    return (
        <>
            <SavedPosts />
        </>
    )
}